import React from 'react';

export const Modal = ({ open, onClose, title, children, maxWidth }) => {
  if (!open) return null;

  const handleOverlay = (e) => {
    if (e.target === e.currentTarget) onClose && onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleOverlay}>
      <div className="modal" style={maxWidth ? { maxWidth } : undefined}>
        {title && (
          <div className="modal-header">
            <div className="modal-title">{title}</div>
            <button className="modal-close" onClick={onClose}>×</button>
          </div>
        )}
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
};
